import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {mcpAccountEntitlementsStateSelector} from './mcp-account-entitlements-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const mcpAccountEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('mcpAccountEntitlements');

export const mcpAccountEntitlementsActions = mcpAccountEntitlementsSlice.actions;
const mcpAccountEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.userPage.tabs.userEntitlements.mcp.accountEntitlements.entitlements.cache;
export const mcpAccountEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.userPage.tabs.userEntitlements.mcp.accountEntitlements.entitlements;
export const mcpAccountEntitlementsResultSelector = getCachedTableResultSelector(
    mcpAccountEntitlementsCacheSelector,
    mcpAccountEntitlementsStateSelector,
);
